import { render, staticRenderFns } from "./FirstReward.vue?vue&type=template&id=54c1a93e&scoped=true&"
import script from "./FirstReward.vue?vue&type=script&lang=js&"
export * from "./FirstReward.vue?vue&type=script&lang=js&"
import style0 from "./FirstReward.vue?vue&type=style&index=0&id=54c1a93e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1a93e",
  null
  
)

export default component.exports